import { render, staticRenderFns } from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=template&id=ef492946&scoped=true&"
import script from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=script&lang=js&"
export * from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=script&lang=js&"
import style0 from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=style&index=0&id=ef492946&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef492946",
  null
  
)

export default component.exports